// @flow
import React from 'react';
import { ArrowDown } from '@finect/tabular-icons/arrowDown';
import { LoadMore } from '../Loading';
import { ADVISERS_PER_PAGE } from '../../data/advisers';

type Props = {
  paging: Object,
  page: number,
  fetching: boolean,
  nextPath: string,
  onLoadMore: Function
};

/**
 * Pie de los listados de asesores: botón de "ver más" mientras queden páginas
 * y aviso de fin de listado en la última. No pinta nada hasta que la API ha
 * devuelto paginación.
 *
 * @param paging     Objeto `paging` de la API (totalItems, limit).
 * @param page       Página cargada actualmente.
 * @param fetching   Si hay una petición en curso.
 * @param nextPath   URL de la página siguiente: se pinta como href para que sea
 *                   rastreable, aunque el click lo intercepte el scroll infinito.
 * @param onLoadMore Handler del botón de "ver más".
 */
export const AdvisersPager = ({ paging, page, fetching, nextPath, onLoadMore }: Props) => {
  if (!paging.hasOwnProperty('totalItems')) return null;

  const pages = Math.ceil(paging.totalItems / paging.limit);

  return (
    <div>
      {page === pages ? (
        <LoadMore light={true} disabled={true} loading={false}>
          Has llegado al final
        </LoadMore>
      ) : null}

      {page < pages ? (
        <LoadMore onClick={onLoadMore} loading={fetching} rel="next" href={nextPath}>
          Ver {paging.totalItems - page * ADVISERS_PER_PAGE} asesores más
          <ArrowDown size={16} />
        </LoadMore>
      ) : null}
    </div>
  );
};
